import type { Voucher, VoucherCreate, VoucherType, VoucherUpdate } from '@erp/shared';

import { api } from './api.js';

export interface VoucherFilter {
  type?: VoucherType;
  from?: string;
  to?: string;
  status?: string;
  partyId?: string;
}

export async function listVouchers(filter: VoucherFilter = {}): Promise<Voucher[]> {
  const q = new URLSearchParams();
  if (filter.type) q.set('type', filter.type);
  if (filter.from) q.set('from', filter.from);
  if (filter.to) q.set('to', filter.to);
  if (filter.status) q.set('status', filter.status);
  if (filter.partyId) q.set('partyId', filter.partyId);
  const qs = q.toString();
  return (await api().get<{ items: Voucher[] }>(`/vouchers${qs ? `?${qs}` : ''}`)).data.items;
}

export async function createVoucher(input: VoucherCreate): Promise<Voucher> {
  return (await api().post<Voucher>('/vouchers', input)).data;
}

export async function updateVoucher(id: string, input: VoucherUpdate): Promise<Voucher> {
  return (await api().patch<Voucher>(`/vouchers/${id}`, input)).data;
}

export async function voidVoucher(id: string): Promise<Voucher> {
  return (await api().post<Voucher>(`/vouchers/${id}/void`, {})).data;
}

export async function deleteVoucher(id: string): Promise<void> {
  await api().delete(`/vouchers/${id}`);
}
